/**
 * 路口配时实体
 */
import React, { Component } from 'react';
import { Modal, Input,Row,Col, message, Select, InputNumber, Checkbox } from 'antd';
import $ from 'jquery';
import { AddRequestHeaders } from '../../incs/FunHelper';
import CNF from '../../incs/Config';

const MODULENAME = '路口配时'


const Option = Select.Option;

const focusStyle = {
    lineHeight: 2.2,
    paddingLeft: 5,
    color: 'red'
}

class Entity extends Component{
    constructor(props){
        super(props);
        this.state = {
            loading: false,
            ulid: '',
            intersectionUlid: '',
            intersectionName: '',
            week: ['1','2','3','4','5'],
            timePeriod: '',
            direction: '',
            duration: 0,
        }
    }


    changeIntersectionUlid = (value, operations) =>{
        this.setState({ intersectionUlid: value,intersectionName:operations.children});}
    changeWeek = (weeks) =>{this.setState({week: weeks});}
    changeTimePeriod = (e) =>{this.setState({timePeriod: e.target.value});}
    changeDirection = (e) =>{this.setState({direction: e.target.value});}
    changeDuration = (value) =>{this.setState({ duration: value });}

    create = () =>{
        const _this = this;

        //  执行创建
        $.ajax({
            url: `${CNF.api}intersection/timings`,
            headers: AddRequestHeaders(),
            type: 'POST',
            dataType: 'JSON',
            data:JSON.stringify({
                'intersection_ulid': this.state.intersectionUlid,
                'intersection_name': this.state.intersectionName,
                'week': this.state.week,
                'time_period': this.state.timePeriod,
                'direction': this.state.direction,
                'duration': this.state.duration,
            }),success:function(data){
                if(data.res === 0){
                    message.success(data.msg, 1);
                    setTimeout(function(){
                        _this.handleCancel();
                        _this.props.isRefresh();
                    }, 1500);
                }else{
                    message.error(data.msg, 1.5);
                    _this.setState({ loading: false });
                }
            }
        });
    };

    update = () =>{
        const _this = this;

        //  执行更新
        $.ajax({
            url: `${CNF.api}intersection/timings/${this.state.ulid}`,
            headers: AddRequestHeaders(),
            type: 'PUT',
            dataType: 'JSON',
            data:JSON.stringify({
                'action': 'UPDATE',
                'intersection_ulid': this.state.intersectionUlid,
                'intersection_name': this.state.intersectionName,
                'week': this.state.week,
                'time_period': this.state.timePeriod,
                'direction': this.state.direction,
                'duration': this.state.duration,
            }),success:function(data){
                if(data.res === 0){
                    message.success(data.msg, 1);
                    setTimeout(function(){
                        _this.handleCancel();
                        _this.props.isRefresh();
                    }, 1500);
                }else{
                    message.error(data.msg, 1.5);
                    _this.setState({ loading: false });
                }
            }
        });
    };

    handleOk = () =>{
        //  参数校验
        if(this.state.intersectionUlid === ''){
            message.error('路口不能为空！');
            return;
        }
        // 校验开机与关机时间
        let regex = /^([0-2][0-9]):[0-6][0-9]-([0-2][0-9]):[0-6][0-9]$/;
        if(!regex.test(this.state.timePeriod)){
            message.error('时段格式错误！');
            return;
        }
        this.setState({loading: true});
        if (this.props.record){
            this.update();
        }else{
            this.create();
        }
    };
    
    handleCancel = () =>{
        this.props.setIsModalOpen(false);
        this.setState({
            loading: false,
            ulid: '',
            intersectionUlid: '',
            intersectionName: '',
            week: ['1','2','3','4','5'],
            timePeriod: '',
            direction: '',
            duration: 0,
        });
    };

    componentDidUpdate(){
        if (this.props.record && this.state.ulid !== this.props.record.key){
            this.setState({
                record: this.props.record,
                ulid: this.props.record.key,
                intersectionUlid: this.props.record.intersection_ulid,
                intersectionName: this.props.record.intersection_name,
                week: this.props.record.week,
                timePeriod: this.props.record.time_period,
                direction: this.props.record.direction,
                duration: this.props.record.duration,
            });
        }
    }
  
    render() {
        return (
            <div>
                <Modal
                    width={450}
                    title={(this.props.record?'修改':'创建') + MODULENAME}
                    open={this.props.isModalOpen}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    keyboard={true}
                    okText='确认'
                    cancelText='取消'
                    okButtonProps={{ disabled: this.state.loading }}
                >
                    <Row style={{ marginTop: 10,lineHeight: 2.2 }}>
                        <Col span={3}>路口：</Col>
                        <Col span={20}>
                            <Select 
                                showSearch
                                value={this.state.intersectionUlid.toString()}
                                style={{ width: '100%' }} 
                                onChange={this.changeIntersectionUlid}
                                disabled={this.state.loading}
                                filterOption={(input, option) =>
                                    option.props.children.indexOf(input) >= 0
                                }
                            >
                                <Option value=''>选择路口</Option>
                                {
                                    this.props.intersectionDDList.length && this.props.intersectionDDList.map((item) => {
                                        return <Option key={item['key']} value={item['key'].toString()}>{item['name']}</Option>
                                    })
                                }
                            </Select>
                        </Col>
                        <Col span={1} style={focusStyle}>*</Col>
                    </Row>
                    <Row style={{ marginTop: 10, lineHeight: 2.2 }}>
                        <Col span={3}>星期：</Col>
                        <Col span={20}>
                            <Checkbox.Group
                                style={{ width: '100%',}}
                                onChange={this.changeWeek}
                                value={this.state.week}
                            >
                                <Row>
                                    <Col span={6}>
                                        <Checkbox value='1'>星期一</Checkbox>
                                    </Col>
                                    <Col span={6}>
                                        <Checkbox value='2'>星期二</Checkbox>
                                    </Col>
                                    <Col span={6}>
                                        <Checkbox value='3'>星期三</Checkbox>
                                    </Col>
                                    <Col span={6}>
                                        <Checkbox value='4'>星期四</Checkbox>
                                    </Col>
                                    <Col span={6}>
                                        <Checkbox value='5'>星期五</Checkbox>
                                    </Col>
                                    <Col span={6}>
                                        <Checkbox value='6'>星期六</Checkbox>
                                    </Col>
                                    <Col span={6}>
                                        <Checkbox value='0'>星期日</Checkbox>
                                    </Col>
                                </Row>
                            </Checkbox.Group>
                            <Checkbox indeterminate={this.state.week.length>0 && this.state.week.length<7} checked={this.state.week.length===7} onChange={()=>{
                                this.setState({
                                    week: this.state.week.length === 7 ? []:['1','2','3','4','5','6','0']
                                });
                            }} >全选</Checkbox>
                        </Col>
                        <Col span={1} style={focusStyle}>*</Col>
                    </Row>
                    <Row style={{ marginTop: 10, lineHeight: 2.2 }}>
                        <Col span={3}>时段：</Col>
                        <Col span={20}>
                            <Input
                                onChange={this.changeTimePeriod}
                                value={this.state.timePeriod}
                                disabled={this.state.loading}
                            />
                        </Col>
                        <Col span={1} style={focusStyle}>*</Col>
                    </Row>
                    <Row style={{ marginTop: 10, lineHeight: 2.2 }}>
                        <Col span={3}>方向：</Col>
                        <Col span={20}>
                            <Input
                                onChange={this.changeDirection}
                                value={this.state.direction}
                                disabled={this.state.loading}
                            />
                        </Col>
                        <Col span={1} style={focusStyle}>*</Col>
                    </Row>
                    <Row style={{ marginTop: 10, lineHeight: 2.2 }}>
                        <Col span={3}>时长：</Col>
                        <Col span={20}>
                            <InputNumber
                                onChange={this.changeDuration}
                                value={this.state.duration}
                                formatter={value => `秒 ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                // parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                min={-2}
                                step='1'
                                stringMode
                                style={{ width: '100%' }} 
                                disabled={this.state.loading} 
                            />
                        </Col>
                        <Col span={1} style={focusStyle}>*</Col>
                    </Row>
                </Modal>
            </div>
        );
    }
}

export default Entity